import React from 'react'

import {
  cardsStyle,
  stepCardStyle,
} from './styles'

import {
  innerWrapperStyle,
} from 'inside-out/page-styles/medicare'

import {
  lightGrey
} from 'inside-out/global-styles'



function StepCard({title, onClick, color, active}) {
  return (<div onClick={ onClick } style={{background: active && color || lightGrey }} className={stepCardStyle}>
    { title }
  </div>)
}

function StepSelect({step, setStep, color}) {
  return (<section className={cardsStyle}>
    <div className={innerWrapperStyle} style={{ display: 'flex', overflowX: 'visible' }}>
      <StepCard
        onClick={ () => setStep(1) }
        title="Initiating Treatment"
        color={ color }
        active={ step === 1}
      />
      <StepCard
        onClick={ () => setStep(2) }
        title="Sessions 1-10"
        color={ color }
        active={ step === 2}
      />
      <StepCard
        onClick={ () => setStep(3) }
        title="Sessions 11-20"
        color={ color }
        active={ step === 3}
      />
      <StepCard
        onClick={ () => setStep(4) }
        title="Sessions 21-30"
        color={ color }
        active={ step === 4}
      />
      <StepCard
        onClick={ () => setStep(5) }
        title="Sessions 31-40"
        color={ color }
        active={ step === 5}
      />
    </div>
  </section>)
}

export { StepSelect }



// WEBPACK FOOTER //
// ./src/components/medicare/stepSelect/index.js